module.exports = __webpack_public_path__ + "img/268-5.f95c19e1.jpg";